import React from 'react';
import NavigationTreeGrid from './NavigationTreeGrid';
import BaseGrid from './BaseGrid';
import { SortDescriptor } from '@progress/kendo-data-query';

/**
 * @class BaseTreeGrid
 * BaseGrid with default props
 */
export default class BaseTreeGrid extends BaseGrid {
  /**
   * Default grid props
   * @private gridDefaults
   */
  protected gridDefaults = {
    keyboardShortcuts: true,
    id: 'BaseTreeGrid',
    pageSize: 20,
    pageSizeName: 'size',
    pageNumberName: 'page',
    rowHeight: 45,
    reorderable: true,
    resizable: true,
    sortable: true,
    uniqueField: 'name',
    nonResizableColumns: [],
    nonReordeableColumns: [],
    columns: [],
    isTree: true,

    onAnyKeyDown: () => {},   
    onRowControls: () => {},    
    onRowDoubleClick: () => {}
  };

  /**
   * Executes expand all regardless user didn't click on toggle button
   * @param {Boolean} forceExpanded
   */
  public executeExpandAll = (forceExpanded?: boolean | undefined) => {
    this.gridRef.wrapGridRef.setForceExpanded(forceExpanded);
  }

  /**
   * Set sort in NavigationBaseGrid
   * @param {SortDescriptor[]} sort
   */
  public setSort = (sort: SortDescriptor[]):void => {
    this.gridRef.wrapGridRef.setSort(sort);
  }

  renderBody(): any {
    let props = {
      ...this.gridDefaults,
      ...this.props
    };

    return (
      <NavigationTreeGrid
        {...props}
        ref={this.setGridReference}
      />
    );
  }
}
